import { useState } from 'react'
import { HelpCircle, X } from 'lucide-react'
import SliderComponent from './SliderComponent'

function QuestionCard({ question, value, onChange, questionIndex, totalQuestions, onSliderRelease }) {
  const [showHint, setShowHint] = useState(false)
  
  const getStatusColor = (value) => {
    if (value === null || value === undefined) {
      return {
        color: '#6b7280',
        text: 'À RENSEIGNER',
        bgColor: '#f3f4f6',
        textColor: '#6b7280',
        borderColor: '#d1d5db'
      }
    }
    
    if (value <= 2) return {
      color: '#dc3545',
      text: 'CRITIQUE',
      bgColor: '#fef2f2',
      textColor: '#dc3545',
      borderColor: '#dc3545'
    }
    if (value <= 4) return {
      color: '#fd7e14',
      text: 'FAIBLE',
      bgColor: '#fff7ed',
      textColor: '#fd7e14',
      borderColor: '#fd7e14'
    }
    if (value <= 6) return {
      color: '#ffc107',
      text: 'MOYEN',
      bgColor: '#fffbeb',
      textColor: '#f59e0b',
      borderColor: '#f59e0b'
    }
    if (value <= 8) return {
      color: '#28a745',
      text: 'BON',
      bgColor: '#f0fdf4',
      textColor: '#28a745',
      borderColor: '#28a745'
    }
    return {
      color: '#198754',
      text: 'EXCELLENT',
      bgColor: '#f0fdf4',
      textColor: '#198754',
      borderColor: '#198754'
    }
  }

  const status = getStatusColor(value)
  const isCompleted = value !== null && value !== undefined

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      {/* Question Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <span className="bg-cedec-blue text-white text-sm font-medium px-3 py-1 rounded-full">
              {questionIndex + 1}/{totalQuestions}
            </span>
            <button
              onClick={() => setShowHint(!showHint)}
              className="flex items-center gap-1 text-cedec-blue hover:text-blue-700 transition-colors"
              title="Afficher l'aide"
            >
              <HelpCircle className="w-5 h-5" />
              <span className="text-sm font-medium">Aide</span>
            </button>
          </div>
          
          <h3 className="text-lg font-semibold text-gray-800 leading-relaxed mb-3">
            {question.title}
          </h3>
        </div>
        
        <span
          className={`px-3 py-1 rounded-full text-sm font-semibold transition-all ${
            isCompleted ? 'text-white' : 'border-2 border-dashed'
          }`}
          style={{
            backgroundColor: isCompleted ? status.color : 'transparent',
            borderColor: !isCompleted ? status.borderColor : 'transparent',
            color: !isCompleted ? status.textColor : 'white'
          }}
        >
          {status.text}
        </span>
      </div>

      {/* Hint Panel */}
      {showHint && (
        <div className="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-4 relative">
          <button
            onClick={() => setShowHint(false)}
            className="absolute top-2 right-2 text-blue-600 hover:text-blue-800"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-start gap-3">
            <HelpCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="font-semibold text-blue-800 mb-2">Aide à l'évaluation</h4>
              <p className="text-blue-700 text-sm leading-relaxed">
                {question.description}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Score Slider */}
      <div className="mb-4">
        <SliderComponent
          value={value}
          onChange={onChange}
          domainName={question.title}
          onRelease={onSliderRelease}
        />
      </div>

      {/* Score Display */}
      <div className={`text-center font-semibold transition-colors ${
        isCompleted ? 'text-cedec-blue' : 'text-gray-400'
      }`}>
        {isCompleted 
          ? `Score attribué : ${value}/10` 
          : 'Utilisez le curseur pour évaluer cette question'
        }
      </div>
    </div>
  )
}

export default QuestionCard
